import { useMemo } from "react";
import { Rocket, Save } from "lucide-react";

export default function ActionsSidebar({ form, categories }) {
  const {
    formData,
    setFormData,
    handleSubmit,
    productId,
    productToEdit,
    loading,
    isSubmitting,
    groupColorsByVariant,
  } = form;

  const isEdit = !!(productId || productToEdit);

  const disabled =
    isSubmitting ||
    loading ||
    (Array.isArray(categories) && categories.length === 0);

  const activeVariants = useMemo(() => {
    if (formData.singleVarinet) {
      return formData.colors?.length ? 1 : 0;
    }
    return Object.keys(groupColorsByVariant(formData.colors || [])).length;
  }, [formData, groupColorsByVariant]);

  const handleSave = async (e) => {
    e.preventDefault();
    setFormData((prev) => ({
      ...prev,
      currency: prev.currency || "PKR",
    }));
    await Promise.resolve();
    handleSubmit();
  };

  return (
    <div className="pf-sidebar-dark space-y-4">
      <div className="flex items-end justify-between gap-3">
        <div>
          <p className="text-[10px] uppercase tracking-wider text-white/50 mb-1">
            Active Variants
          </p>
          <p className="text-3xl font-bold tabular-nums leading-none">
            {String(activeVariants).padStart(2, "0")}
          </p>
        </div>
      </div>

      <p className="text-[11px] text-white/55 leading-relaxed">
        {isEdit
          ? "Update product details, variants, and images, then save."
          : "Complete technical specs and at least one variant before publishing."}
      </p>

      <div className="flex items-center justify-between gap-2 pt-1 border-t border-white/10">
        <div>
          <p className="text-[10px] uppercase tracking-wider text-white/50">
            Visibility
          </p>
          <p className="text-xs font-semibold mt-0.5">
            {String(formData.status) === "true" ? "Active" : "Inactive"}
          </p>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={String(formData.status) === "true"}
          className={`pf-toggle ${
            String(formData.status) === "true" ? "on" : ""
          }`}
          onClick={() =>
            setFormData((prev) => ({
              ...prev,
              status: String(prev.status) === "true" ? "false" : "true",
            }))
          }
        />
      </div>

      <div className="space-y-2 pt-1">
        <button
          type="button"
          disabled={disabled}
          onClick={handleSave}
          className={`pf-btn-publish inline-flex items-center justify-center gap-2 ${
            formData.singleVarinet ? "pf-btn-publish-yellow" : ""
          }`}
        >
          {isEdit ? <Save size={15} /> : <Rocket size={15} />}
          {isSubmitting
            ? "Processing..."
            : isEdit
              ? "Update Product"
              : "Publish Product"}
        </button>
      </div>
    </div>
  );
}
